import React from "react";

import { FaCheckCircle } from "react-icons/fa";
import Newzealandimport from "@/pages/newzealandimport";
import Newzealandfaq from "@/pages/newzealandfaq";

import Contacts from "@/pages/contacts";

function Newzealand() {
  

 
  const SectionIconBoxes = () => {
    return (
      <>
        <div className="h-98 relative w-full">
          <img
            src="newzalend.jpg" // Replace with the correct path to your image
            alt="Canada Immigrations"
            className="h-full w-full object-cover"
          />
          <div className="absolute bottom-5 left-5 text-xl md:text-4xl font-bold text-white drop-shadow-md">
            New Zealand
          </div>
        </div>

        <div className="mt-32 w-full px-5 md:mt-20 md:w-full md:px-20 lg:mt-32 xl:mt-32">
          <p className="mb-5 text-center text-4xl font-bold text-[#011473] md:text-6xl">
            Available Visa Options
          </p>

          <div className="container mx-auto mb-10 mt-14">
            <div className="grid grid-cols-1 gap-6 lg:grid-cols-4 xl:grid-cols-4">
              {/* Skilled Migration Visa */}
              <div className="hover:shadow-xl group relative flex h-64 transform flex-col items-center rounded-xl border p-2 text-center shadow-md transition-transform duration-300 hover:scale-105 hover:cursor-pointer">
                <img
                  src="/img.jpg"
                  alt="Skilled Migration Visa"
                  className="mb-4 h-40 w-40 transition-opacity duration-300 group-hover:opacity-0"
                />
                <h2 className="text-xl font-medium text-[#011473] transition-opacity duration-300 group-hover:opacity-0 md:text-xl">
                  Skilled Migration Visa
                </h2>
                <div className="absolute inset-0 flex flex-col items-center justify-center opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                  <p className="mb-4 text-center text-md">
                  The Skilled Migrant Category offers unrestricted movement in and out of New Zealand, with Visa World providing expert guidance for a smooth migration process.
                  </p>
                  <a href="/newzealand-skilled-migration-visa">
                    <button className="rounded-lg bg-blue-500 px-4 py-2 text-white transition-colors duration-300 hover:bg-blue-600">
                      Read More
                    </button>
                  </a>
                </div>
              </div>

              {/* Investor Visa */}
              <div className="hover:shadow-xl group relative flex h-64 transform flex-col items-center rounded-xl border p-8 text-center shadow-md transition-transform duration-300 hover:scale-105 hover:cursor-pointer">
                <img
                  src="/investor.jpg"
                  alt="Investor Visa"
                  className="mb-4 h-96 w-60 transition-opacity duration-300 group-hover:opacity-0"
                />
                <h2 className="text-xl font-medium text-[#011473] transition-opacity duration-300 group-hover:opacity-0 md:text-xl">
                  Investor Visa
                </h2>
                <div className="absolute inset-0 flex flex-col items-center justify-center opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                  <p className="mb-4 text-center text-md">
                  Visa World supports you in navigating investment opportunities and starting businesses in New Zealand, ensuring a seamless experience.
                  </p>
                  <a href="/newzealand-investor-visa">
                    <button className="rounded-lg bg-blue-500 px-4 py-2 text-white transition-colors duration-300 hover:bg-blue-600">
                      Read More
                    </button>
                  </a>
                </div>
              </div>

              {/* Student Visa */}
              <div className="hover:shadow-xl group relative flex h-64 transform flex-col items-center rounded-xl border p-8 text-center shadow-md transition-transform duration-300 hover:scale-105 hover:cursor-pointer">
                <img
                  src="/student.jpg"
                  alt="Student Visa"
                  className="mb-4 h-40 w-40 transition-opacity duration-300 group-hover:opacity-0"
                />
                <h2 className="text-xl font-medium text-[#011473] transition-opacity duration-300 group-hover:opacity-0 md:text-xl">
                  Student Visa
                </h2>
                <div className="absolute inset-0 flex flex-col items-center justify-center opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                  <p className="mb-4 text-center text-md">
                  Studying in New Zealand opens up a world of possibilities, offering students invaluable skills, experiences and global connections.
                  </p>
                  <a href="/newzealand-student-visa">
                    <button className="rounded-lg bg-blue-500 px-4 py-2 text-white transition-colors duration-300 hover:bg-blue-600">
                      Read More
                    </button>
                  </a>
                </div>
              </div>

              {/* Visit Visa */}
              <div className="hover:shadow-xl group relative flex h-64 transform flex-col items-center rounded-xl border p-2 text-center shadow-md transition-transform duration-300 hover:scale-105 hover:cursor-pointer">
                <img
                  src="/visit.jpg"
                  alt="Visit Visa"
                  className="mb-4 h-40 w-40 transition-opacity duration-300 group-hover:opacity-0"
                />
                <h2 className="text-xl font-medium text-[#011473] transition-opacity duration-300 group-hover:opacity-0 md:text-xl">
                  Visit Visa
                </h2>
                <div className="absolute inset-0 flex flex-col items-center justify-center opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                  <p className="mb-4 text-center text-md">
                  Explore New Zealand for tourism, business, medical consultations, or to reconnect with family members on a short-term basis.
                  </p>
                  <a href="/newzealand-visit-visa">
                    <button className="rounded-lg bg-blue-500 px-4 py-2 text-white transition-colors duration-300 hover:bg-blue-600">
                      Read More
                    </button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <section className="bg-white px-4 py-10">
        <h2 className="mb-14 text-3xl text-center font-bold text-[#011473]">
        Why Visa World is Your Best Choice for New Zealand Migration
      </h2>

  <div className="container mx-auto flex flex-wrap items-center">
    {/* Left Side Image */}
    <div className="w-full md:w-1/2 mb-6 md:mb-0">
      <img
        src="/imaged.jpg"
        alt="New Zealand Migration"
        className="w-3/3 h-96 rounded-lg shadow-md"
      />
    </div>

    {/* Right Side Content */}
    <div className="w-full md:w-1/2 text-left">
      
      <div className="grid grid-cols-1 gap-6 text-left">
        <ul className="space-y-4 space-x-6">
          <li className="flex items-start">
            <FaCheckCircle className="mt-1 ml-6 h-6 w-6 flex-shrink-0 text-blue-500" />
            <p className="ml-4 text-gray-700">
              Discover the natural beauty and warm hospitality of New Zealand.
            </p>
          </li>
          <li className="flex items-start">
            <FaCheckCircle className="mt-1 h-6 w-6 flex-shrink-0 text-blue-500" />
            <p className="ml-4 text-gray-700">
              Access top-tier healthcare services, ensuring well-being for you and your family.
            </p>
          </li>
          <li className="flex items-start">
            <FaCheckCircle className="mt-1 h-6 w-6 flex-shrink-0 text-blue-500" />
            <p className="ml-4 text-gray-700">
              Enjoy a safe, secure environment conducive to a high quality of life.
            </p>
          </li>
          <li className="flex items-start">
            <FaCheckCircle className="mt-1 h-6 w-6 flex-shrink-0 text-blue-500" />
            <p className="ml-4 text-gray-700">Easily access permanent residency options.</p>
          </li>
          <li className="flex items-start">
            <FaCheckCircle className="mt-1 h-6 w-6 flex-shrink-0 text-blue-500" />
            <p className="ml-4 text-gray-700">
              Achieve a balanced lifestyle in one of the world’s most peaceful and welcoming countries.
            </p>
          </li>
          <li className="flex items-start">
            <FaCheckCircle className="mt-1 h-6 w-6 flex-shrink-0 text-blue-500" />
            <p className="ml-4 text-gray-700">
              Benefit from New Zealand's excellent and affordable educational opportunities.
            </p>
          </li>
          <li className="flex items-start">
            <FaCheckCircle className="mt-1 h-6 w-6 flex-shrink-0 text-blue-500" />
            <p className="ml-4 text-gray-700">
              Take advantage of a growing economy, full of exciting opportunities.
            </p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</section>


        <Newzealandimport />
        <section className="bg-white px-4 py-8">
          <div className="container mx-auto">
            {/* Section Heading */}
            <h2 className="mb-6 text-2xl font-bold text-[#011473] md:text-3xl">
              How Visa World Guides Your Journey
            </h2>

            {/* List Items */}
            <ul className="space-y-4">
              <li className="flex items-start">
                <FaCheckCircle className="mt-1 h-6 w-6 flex-shrink-0 text-blue-500" />
                <p className="ml-4 text-gray-700">
                  Our expert team works closely with each client to understand
                  their goals and provides tailored advice while navigating the
                  immigration process.
                </p>
              </li>

              <li className="flex items-start">
                <FaCheckCircle className="mt-1 h-6 w-6 flex-shrink-0 text-blue-500" />
                <p className="ml-4 text-gray-700">
                  We partner with ICCRC-registered consultants and
                  MARA-registered agents to ensure your application is managed
                  according to the best standards.
                </p>
              </li>

              <li className="flex items-start">
                <FaCheckCircle className="mt-1 h-6 w-6 flex-shrink-0 text-blue-500" />
                <p className="ml-4 text-gray-700">
                  From skilled migration to study abroad and business migration,
                  we offer end-to-end support, covering all your needs from
                  start to finish.
                </p>
              </li>

              <li className="flex items-start">
                <FaCheckCircle className="mt-1 h-6 w-6 flex-shrink-0 text-blue-500" />
                <p className="ml-4 text-gray-700">
                  With a remarkable 98% success rate, we have successfully
                  helped over 5,000 clients achieve their immigration
                  objectives.
                </p>
              </li>
            </ul>
          </div>
        </section>

        <Newzealandfaq />
        <Contacts />
      </>
    );
  };

  return <SectionIconBoxes />;
}

export default Newzealand;
